/* Shared Kundeklub tag-assembly + "Jeg er Spejder" group-select behavior.
 * Card FEnxDdvH: the kundeklub signup drawer
 * (spejder-member-signup-drawer.liquid) and the on-page Kundeklub tilmelding section
 * (sections/spejder-member-signup.liquid) both need to (a) reveal/drive the
 * "Vælg Spejder gruppe" listbox (snippets/scout-group-select.liquid) the
 * exact same way, and (b) build the same "base tag(s) + optional spejder
 * tag + optional gruppe: <value>" customer-tags string on submit. This file
 * is the single implementation both callers share — extracted from
 * spejder-member-signup.liquid's old per-section inline <script> so the two
 * surfaces can't drift out of sync (Q/A 1 DRY gate).
 *
 * window.SpejderMember.initSpejderGroup(root)
 *   -> wires the [data-member-scout] checkbox to reveal
 *      [data-member-scout-group-wrap], plus that wrap's own toggle/listbox/keyboard
 *      behavior. Scoped to `root` so multiple instances (section + modal,
 *      or two theme-editor previews) never cross-wire each other.
 */
window.SpejderMember = window.SpejderMember || {};

(function (ns) {
  function initSpejderGroup(root) {
    if (!root) return;
    var spejder = root.querySelector('[data-member-scout]');
    var groupWrap = root.querySelector('[data-member-scout-group-wrap]');
    if (!spejder || !groupWrap || groupWrap.__spejderGroupBound) return;
    groupWrap.__spejderGroupBound = true;

    spejder.addEventListener('change', function () {
      groupWrap.hidden = !spejder.checked;
    });

    var toggle = groupWrap.querySelector('[data-member-scout-group-toggle]');
    var list = groupWrap.querySelector('[data-member-scout-group-list]');
    var label = groupWrap.querySelector('[data-member-scout-group-label]');
    var hiddenInput = groupWrap.querySelector('[data-member-scout-group]');
    if (!toggle || !list || !hiddenInput) return;

    function closeList() {
      list.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      var open = list.hidden;
      list.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    list.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-member-scout-group-option]');
      if (!opt) return;
      hiddenInput.value = opt.getAttribute('data-value');
      if (label) label.textContent = opt.textContent.trim();
      toggle.classList.add('has-value');
      closeList();
      toggle.focus();
    });

    document.addEventListener('click', function (e) {
      if (!groupWrap.contains(e.target)) closeList();
    });

    groupWrap.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeList();
        toggle.focus();
      }
    });
  }

  function resetSpejderGroup(root) {
    if (!root) return;
    var spejder = root.querySelector('[data-member-scout]');
    var groupWrap = root.querySelector('[data-member-scout-group-wrap]');
    var hiddenInput = root.querySelector('[data-member-scout-group]');
    var label = root.querySelector('[data-member-scout-group-label]');
    var toggle = root.querySelector('[data-member-scout-group-toggle]');
    if (spejder) spejder.checked = false;
    if (groupWrap) groupWrap.hidden = true;
    if (hiddenInput) hiddenInput.value = '';
    if (toggle) toggle.classList.remove('has-value');
    if (label && toggle) {
      var list = root.querySelector('[data-member-scout-group-list]');
      // Restore the server-rendered placeholder text (first render), not a
      // stale selected value — cheapest correct reset is re-reading the
      // aria-label the listbox already carries.
      var listboxLabel = list ? list.getAttribute('aria-label') : null;
      if (listboxLabel) label.textContent = listboxLabel;
    }
  }

  // "Jeg er Spejder" info-tooltip on touch (Emil 2026-08-18): the icon sits
  // INSIDE the checkbox <label>, so a tap's default action toggles the
  // checkbox — and touch has no hover to reveal the bubble. A tap on the icon
  // must therefore cancel the label activation and toggle the bubble instead
  // (.is-open, styled next to the :hover reveal in spejder.css). Delegated
  // once per page so every signup surface (kundeklub page, drawer, modal)
  // gets it without per-surface wiring; outside taps and Escape close it.
  document.addEventListener('click', function (e) {
    var tip = e.target.closest ? e.target.closest('.spejder-msd__tooltip') : null;
    var open = document.querySelectorAll('.spejder-msd__tooltip.is-open');
    if (tip) {
      e.preventDefault();
      open.forEach(function (t) { if (t !== tip) t.classList.remove('is-open'); });
      tip.classList.toggle('is-open');
      return;
    }
    open.forEach(function (t) { t.classList.remove('is-open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.spejder-msd__tooltip.is-open').forEach(function (t) { t.classList.remove('is-open'); });
  });

  ns.initSpejderGroup = initSpejderGroup;
  ns.resetSpejderGroup = resetSpejderGroup;
})(window.SpejderMember);
